import { IApplicationMessagePayload } from './application-messages-payload.interface';
import { Action } from '@ngrx/store';

export class ApplicationMessagesAction implements Action {

    public static genericError = '[Application Messages] generic_error';
    public static genericErrorStarted = '[Application Messages] generic_error_started';
    public static genericErrorCompleted  = '[Application Messages] generic_error_completed';

    public static toastError = '[Application Messages] error';
    public static toastErrorCompleted  = '[Application Messages] error_completed';

    public static toastWarningMessage = '[Application Messages] toast_warning';
    public static toastWarningMessageCompleted = '[Application Messages] toast_warning_completed';

    public static toastSuccessMessage = '[Application Messages] toast_success_message';
    public static toastSuccessMessageCompleted = '[Application Messages] toast_success_message_completed';

    public static toastInfoMessage = '[Application Messages] toast_info_message';
    public static toastInfoMessageCompleted = '[Application Messages] toast_info_message_completed';

    public static toastMessageDisposed = '[Application Messages] toast_message_disposed';

    constructor(
        public type: string,
        public payload: IApplicationMessagePayload,
    ) {}
}
